<div [formGroup]="form">
    <div
        class="btn-group btn-group-toggle"
        [formControlName]="'which'"
        ngbRadioGroup
    >
        <ng-container *ngFor="let i of PresentationViewOpts">
            <label
                class="btn-primary"
                ngbButtonLabel
            >
                <input
                    type="radio"
                    [value]="i.type"
                    ngbButton
                />
                {{ i.tlKey | translate }}
            </label>
        </ng-container>
    </div>
</div>
